import {Component, Inject, OnInit} from '@angular/core';
import {WorkstationConfigurationModel} from '../../../../../models/configuration/workstation-configuration.model';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DialogService} from '../../../../../services/dialog.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {PaymentProcessorConfigurationService} from '../../payment-processor-configuration..service';
import {CfgArPaymentProcessorDeviceModel} from '../../../../../models/accountsReceivable/cfg-ar-payment-processor-device.model';
import {PaymentProcessorDeviceListModel} from '../../../models/payment-processor-device-list.model';

@Component({
  selector: 'app-payment-processor-device-dialog',
  templateUrl: './payment-processor-device-dialog.component.html',
  styleUrls: ['./payment-processor-device-dialog.component.scss']
})
export class PaymentProcessorDeviceDialogComponent implements OnInit {

  locid: number;
  workStations: WorkstationConfigurationModel[] = [];
  workStationsFiltered: WorkstationConfigurationModel[] = [];
  workStation: WorkstationConfigurationModel;
  processorDevice: CfgArPaymentProcessorDeviceModel;
  processorDevices: PaymentProcessorDeviceListModel[] = [];
  paymentDeviceID: string;
  paymentProcessorID: string;
  isLoading: boolean;

  constructor(
                  @Inject(MAT_DIALOG_DATA) public data: any,
                  private dialogRef: MatDialogRef<PaymentProcessorDeviceDialogComponent>,
                  private snackBar: MatSnackBar,
                  private dialogService: DialogService,
                  private snackbar: MatSnackBar,
                  private dialog: MatDialog,
                  private paymentProcessorConfigService: PaymentProcessorConfigurationService,
                  ) { }

  ngOnInit(): void {

    if (this.data.paymentDeviceID && this.data.paymentDeviceID !== '') {
      this.paymentDeviceID = this.data.paymentDeviceID;
    }
    else {
      this.paymentDeviceID = '';
    }
    if (this.data.locid) { this.locid = this.data.locid; }
    if (this.data.paymentProcessorID) { this.paymentProcessorID = this.data.paymentProcessorID; }
    if (this.data.paymentProcessorDevices) { this.processorDevices = this.data.paymentProcessorDevices; }

    // was deviceid passed?
    if (this.paymentDeviceID === '') {
      this.processorDevice = new CfgArPaymentProcessorDeviceModel();
      this.processorDevice.PaymentProcessorId = this.paymentProcessorID;
      this.processorDevice.LOCID = this.locid;
    }
    else {
      this.paymentProcessorConfigService.getPaymentProcessorDevice(this.paymentDeviceID).subscribe((device) => {
        this.processorDevice = device;
      }, err => {
        this.createMessage('Error loading workstation', 'Error');
      });
    }

    // get workstations
    this.paymentProcessorConfigService.getWorkstations(this.locid.toString()).subscribe((ws) => {
      this.workStations = ws;
      if (this.paymentDeviceID === '') {

        // filter out existing workstations
        const wsFiltered: WorkstationConfigurationModel[] = [];
        this.workStations.forEach(a => {
          const exists = this.existsInDevices(a.WorkStationId);
          if (!exists) {
            wsFiltered.push(a);
          }
        });
        this.workStations = wsFiltered;
      }
    }, err => {
      this.createMessage('Error loading workstations for location', 'Error');
    });
  }

  existsInDevices(WorkStationId: string) {
    let exists: boolean = false;
    this.processorDevices.forEach(a => {
      if (a.WorkStationId === WorkStationId) {
        exists = true;
      }
    });
    return exists;
  }

  save() {
    this.paymentProcessorConfigService.saveProcessorDevice(this.processorDevice).subscribe(saved => {
      if (saved)
      {
        // save successful
        this.createMessage('Device workstation saved', 'Success');

        this.processorDevice = saved;
        this.isLoading = false;
        this.dialogRef.close();
      }
    }, err => {
      this.createMessage('Error saving device workstation', 'Error');
      this.isLoading = false;
    });
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  showWorkstation() {
    return true;
  }
}
